import type { SystemStyleObject } from "@chakra-ui/theme-tools"

const baseStyle: SystemStyleObject = {
  fontFamily: "mono",
  fontSize: 'xs',
  px: "0.2em",
  borderRadius: '.25em',
}

export const Code = {
  baseStyle,
}
